import { render } from "./CustomizedContent.vue?vue&type=template&id=22ce1874"
import script from "./CustomizedContent.vue?vue&type=script&lang=ts"
export * from "./CustomizedContent.vue?vue&type=script&lang=ts"

import "./CustomizedContent.vue?vue&type=style&index=0&id=22ce1874&lang=css"
script.render = render

export default script